import { reducer as CrmReducer } from './crm.slice';

export default CrmReducer;
